module.exports = __webpack_public_path__ + "static/media/Replayer_favicon.c8d5330b.png";